define('OutSystems/ClientRuntime/RolesInfo',["require", "exports", "tslib", "./ApplicationInfo", "./Communication", "./CookiesManager", "./Exceptions", "./Logger", "./StorageProvider"], function (require, exports, tslib_1, ApplicationInfo, Communication, CookiesManager, Exceptions, Logger, StorageProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.checkRoles = exports.checkRegistered = exports.getUserId = exports.areRolesDefined = exports.areRolesEmpty = exports.storeRoleInformation = exports.initializeRolesFromServer = exports.initialize = exports.RolesInfoPersistentStorage = exports.RolesInfoStorage = exports.ROLES_INFO_MODULE_NAME = void 0;
    exports.ROLES_INFO_MODULE_NAME = "RolesInfo";
    exports.RolesInfoStorage = {
        rolesInfo: new StorageProvider_1.StorageObject(StorageProvider_1.StorageType.Persistent, exports.ROLES_INFO_MODULE_NAME, null, ApplicationInfo.getUserProviderName),
    };
    function initialize(storage) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var storageReady, _a, userId, roles;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        exports.RolesInfoPersistentStorage = storage;
                        _a = !!exports.RolesInfoPersistentStorage;
                        if (!_a) return [3, 2];
                        return [4, exports.RolesInfoPersistentStorage.isReady()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        storageReady = _a;
                        userId = this.getUserId();
                        if (!(!areRolesDefined() && userId !== 0 && storageReady)) return [3, 4];
                        return [4, exports.RolesInfoPersistentStorage.getValue(exports.ROLES_INFO_MODULE_NAME)];
                    case 3:
                        roles = _b.sent();
                        exports.RolesInfoStorage.rolesInfo.set(roles === "undefined" ? undefined : roles);
                        _b.label = 4;
                    case 4: return [2];
                }
            });
        });
    }
    exports.initialize = initialize;
    function initializeRolesFromServer() {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userId, roles, ex_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = this.getUserId();
                        if (!((!areRolesDefined() || areRolesEmpty()) && userId !== 0 && Communication.NetworkStatus.isOnline())) return [3, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4, Communication.getRoles()];
                    case 2:
                        roles = _a.sent();
                        return [4, storeRoleInformation(roles)];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        ex_1 = _a.sent();
                        Logger.log("RolesInfo", "Failed to load role data from the server for user " + userId + " after not finding it locally: " + (ex_1 === null || ex_1 === void 0 ? void 0 : ex_1.message));
                        return [3, 5];
                    case 5: return [2];
                }
            });
        });
    }
    exports.initializeRolesFromServer = initializeRolesFromServer;
    function storeRoleInformation(rolesInfo, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? "" : _c;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var isNewRolesInfo, rolesBefore, rolesAfter, storageReady;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        isNewRolesInfo = !areRolesDefined() || rolesInfo !== exports.RolesInfoStorage.rolesInfo.get();
                        rolesBefore = exports.RolesInfoStorage.rolesInfo.get();
                        exports.RolesInfoStorage.rolesInfo.set(rolesInfo);
                        rolesAfter = exports.RolesInfoStorage.rolesInfo.get();
                        Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Roles changed from [" + rolesBefore + "] to [" + rolesAfter + "]" + " (Endpoint: " + url + " )");
                        return [4, (exports.RolesInfoPersistentStorage === null || exports.RolesInfoPersistentStorage === void 0 ? void 0 : exports.RolesInfoPersistentStorage.isReady())];
                    case 1:
                        storageReady = _d.sent();
                        if (!(isNewRolesInfo && storageReady)) return [3, 3];
                        return [4, exports.RolesInfoPersistentStorage.setValue(exports.ROLES_INFO_MODULE_NAME, rolesInfo)];
                    case 2:
                        _d.sent();
                        _d.label = 3;
                    case 3: return [2];
                }
            });
        });
    }
    exports.storeRoleInformation = storeRoleInformation;
    function areRolesEmpty() {
        var _a;
        return ((_a = exports.RolesInfoStorage.rolesInfo.get()) === null || _a === void 0 ? void 0 : _a.trim()) === ",";
    }
    exports.areRolesEmpty = areRolesEmpty;
    function areRolesDefined() {
        return exports.RolesInfoStorage.rolesInfo.isDefined();
    }
    exports.areRolesDefined = areRolesDefined;
    function getUserId() {
        var cookieValue = CookiesManager.readCookie(ApplicationInfo.getUserCookieName());
        Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking User's ID: User cookie value (" + cookieValue + ")");
        if (cookieValue === null) {
            return 0;
        }
        var userIdRegex = /uid=(\d+)/;
        var match = cookieValue.match(userIdRegex);
        if (match === null) {
            Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking User's ID: User is Anonymous");
            return 0;
        }
        return parseInt(match[1], 10);
    }
    exports.getUserId = getUserId;
    function checkRegistered() {
        if (this.getUserId() === 0) {
            Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: Not authorized since user is not registered");
            throw new Exceptions.Exceptions.NotRegisteredException("", "Registered role required");
        }
        Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: User authorized since it is registered");
    }
    exports.checkRegistered = checkRegistered;
    function checkRoles(roles) {
        if (this.getUserId() === 0) {
            Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: Not authorized because user is not logged in");
            throw roles[roles.length - 1].roleException;
        }
        if (!areRolesDefined()) {
            Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: Not authorized since user don't have roles for the specified user provider");
            throw roles[roles.length - 1].roleException;
        }
        Logger.trace(exports.ROLES_INFO_MODULE_NAME, function () {
            var requiredRoles = "";
            roles.forEach(function (role) {
                return (requiredRoles += role.roleException.message + " [RoleKey=" + role.roleKey + "] ");
            });
            return "Checking authorization: Required Roles ( " + requiredRoles + ")";
        });
        var rolesInfo = exports.RolesInfoStorage.rolesInfo.get();
        Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: User roles keys (" + rolesInfo + ")");
        if (!roles.some(function (role) {
            return rolesInfo.indexOf(role.roleKey) >= 0;
        })) {
            Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: Not authorized since roles don't match");
            throw roles[roles.length - 1].roleException;
        }
        Logger.trace(exports.ROLES_INFO_MODULE_NAME, "Checking authorization: User authorized due to role match");
    }
    exports.checkRoles = checkRoles;
});
//# sourceMappingURL=RolesInfo.js.map;
